import { CustomElement } from "../../core/CustomElement";
import { CCCDatePicker } from "../forms/date-picker/index";
import { CCCInputText } from "../forms/input-text/index";

// Components
import "../loader/index";
import "../panel/panel";
import "../forms/input-text/index";
import "../forms/date-picker/index";
import "../forms/select-many/selectMany";
import "../forms/button/index";

export class CCCSearchPanel extends CustomElement {
  static get observedAttributes(): Array<string> {
    return ["type"];
  }

  $startDate: CCCDatePicker = null;
  $endDate: CCCDatePicker = null;

  constructor() {
    super();
    this.templateConfig = {
      template: require("./searchPanel.html").default,
      style: require("./searchPanel.scss").default,
      viewModel: require("./searchPanelVm"),
    };
    this.setupComponent();
    setTimeout(() => {
      this.loading = true;
      this.$startDate = this.shadowDom.querySelector(".start-date");
      this.$endDate = this.shadowDom.querySelector(".end-date");
      this.addDateRangePrevents();
    }, 1);
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    switch (attr) {
      case "type": {
        this.viewModel.type(newValue);
        break;
      }
    }
  }

  public subscribeToIdeaNumberVal(callback: (val: string) => void): void {
    const $ideaNumber: CCCInputText = <CCCInputText>(
      this.select("#ideaNumberFld")
    );
    $ideaNumber.subscribeToVal(true, callback);
  }

  public onSearch(onSearch: () => void): void {
    const $searchBtn = this.select("#searchBtn");
    $searchBtn.addEventListener("ccc-button-click", () => {
      onSearch();
    });
  }

  public set loading(val: boolean) {
    const container: CustomElement = this.shadowDom.querySelector(".container");
    if (val) {
      container.style.display = "none";
    } else {
      container.style.display = "flex";
    }
    super.loading = val;
  }

  /**
   * When end date is selected you cannot longer select a greater date in start date and viceversa.
   *
   */
  addDateRangePrevents(): void {
    this.$startDate.subscribeToVal((newDate: string) => {
      this.$endDate.setAttribute("min-date", newDate);
    });

    this.$endDate.subscribeToVal((newDate: string) => {
      this.$startDate.setAttribute("max-date", newDate);
    });
  }
}

// Define component.
if (!customElements.get("ccc-search-panel")) {
  customElements.define("ccc-search-panel", CCCSearchPanel);
}
